/**
 * Toggle
 */

import React from 'react';
import { Button } from 'semantic-ui-react';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';

import './styles.scss';

interface Props {
    handleClick: Function;
    open: boolean;
}

class Toggle extends React.PureComponent<Props> {
    render() {
        const { handleClick, open } = this.props;
        const className = `resizable-container-toggle ${
            open ? 'toggle-up' : 'toggle-down'
        }`;
        return (
            <div style={{ position: 'relative' }}>
                <Button
                    className={className}
                    onClick={handleClick}
                    icon
                    circular
                >
                    {open ? (
                        <FiChevronDown size="18" />
                    ) : (
                        <FiChevronUp size="18" />
                    )}
                </Button>
            </div>
        );
    }
}

export default Toggle;
